import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import { either } from '../../lib/utils/utils';
import styles from '../css/LandingHeader.module.scss';
import ButtonLeftIcon from '../../controls/components/ButtonLeftIcon';
import postGetServerVar from './../../getServerVars';
import { postGetStaticInfo } from '../../postGetStatic';
import CenterProgress from '../../CenterProgress';
import eLocalLogoSVG from '../../images/eLocalLogo.svg';
import WelcomePopup from './WelcomePopup';
import SVG from 'react-inlinesvg';
var deferredPrompt;

window.addEventListener('beforeinstallprompt', function (e) {
	// Prevent Chrome 67 and earlier from automatically showing the prompt
	e.preventDefault();
	// Stash the event so it can be triggered later.
	deferredPrompt = e;

	showAddToHomeScreen();
});

function showAddToHomeScreen() {
	var a2hsBtn = document.querySelector('.ad2hs-prompt');
	if (a2hsBtn) {
		a2hsBtn.style.display = 'block';

		a2hsBtn.addEventListener('click', addToHomeScreen);
	}
}

function addToHomeScreen() {
	var a2hsBtn = document.querySelector('.ad2hs-prompt'); // hide our user interface that shows our A2HS button
	if (a2hsBtn) {
		a2hsBtn.style.display = 'none'; // Show the prompt
	}
	deferredPrompt.prompt(); // Wait for the user to respond to the prompt
	deferredPrompt.userChoice.then(function (choiceResult) {
		if (choiceResult.outcome === 'accepted') {
			console.log('User accepted the A2HS prompt');
		} else {
			console.log('User dismissed the A2HS prompt');
		}

		deferredPrompt = null;
	});
}

const LandingHeader = () => {
	const history = useHistory();
	const location = useLocation();
	const [headerText, setHeaderText] = useState(undefined);
	const [headerLocals, setHeaderLocals] = useState(['']);
	const [headerMotto, setHeaderMotto] = useState(['']);
	const [loginRegistrationButton, setLoginRegistrationButton] =
		useState(undefined);

	useEffect(() => {
		postGetStaticInfo('headerText').then(
			either(console.log, t => setHeaderText(t))
		);
		postGetStaticInfo('headerTop').then(
			either(console.log, ([locals, motto]) => {
				setHeaderLocals(locals);
				setHeaderMotto(motto);
			})
		);
		postGetServerVar('loginRegistrationButton').then(
			either(console.log, b => setLoginRegistrationButton(b))
		);
	}, []);

	const onRegister = () => {
		history.push('/register');
	};

	if (!headerText) {
		return <CenterProgress />;
	}

	const isRegistration = location.pathname === '/register';

	return (
		<div className={styles.wrap}>
			<WelcomePopup />
			<div>
				<div className={styles.logoWrap}>
					<SVG
						viewBox="0 0 512 512"
						className={styles.svgWrap}
						src={eLocalLogoSVG}
					/>
					<div className={styles.toolbarText}>
						{headerLocals.map(text => (
							<span
								style={{
									fontSize:
										12 + 36 / headerLocals.length + 'px'
								}}>
								{text}
							</span>
						))}
					</div>
				</div>
			</div>
			<div className={styles.mainMsgText}>
				{headerMotto.map(text => (
					<span>{text}</span>
				))}
			</div>
			<div className={styles.smallMessage}>{headerText}</div>
			{!isRegistration && (loginRegistrationButton & 1) !== 0 ? (
				<>
					<div className={styles.noAccountMsg}>
						Don't have an account yet?
					</div>
					<ButtonLeftIcon
						color="secondary"
						label="REGISTER"
						icon="notification_important"
						variant="contained"
						onClick={onRegister}
					/>
				</>
			) : null}
		</div>
	);
};

export default LandingHeader;
